import { Component, ElementRef, HostListener, ViewChild } from "@angular/core";
import { SidebarProfileButtonComponent } from "./buttons/route-button/sidebar-button-profile.component";
import { SidebarFriendsButtonComponent } from "./buttons/route-button/sidebar-button-friends.component";
import { SidebarCollectionButtonComponent } from "./buttons/route-button/sidebar-button-collection.component";
import { SidebarDecksButtonComponent } from "./buttons/route-button/sidebar-button-decks.component";
import { SidebarListsButtonComponent } from "./buttons/route-button/sidebar-button-lists.component";
import { SidebarStatsButtonComponent } from "./buttons/route-button/sidebar-button-stats.component";
import { SidebarNewsButtonComponent } from "./buttons/link-button/sidebar-button-news.component";
import { SidebarSupportButtonComponent } from "./buttons/link-button/sidebar-button-support.component";
import { SidebarLogoutButtonComponent } from "./buttons/action-button/sidebar-button-logout.component";
import { Event,  NavigationStart, Router } from "@angular/router";
import { Subscription, take } from "rxjs";
import { AuthService } from "@ponder-core/auth/auth.service";
import { AuthSession } from "@ponder-core/auth/auth-session";
import { SidebarHistoryButtonComponent } from "./buttons/link-button/sidebar-button-history.component";
import { SidebarAccountButtonComponent } from "./buttons/link-button/sidebar-button-account.component";
import { AvatarComponent } from "@ponder-shared/components/avatar.component";
import { NotificationBubbleComponent } from "@ponder-core/notifications/notification-bubble.component";
import { NotificationService } from "@ponder-core/notifications/notification.service";
import { NotificationType } from "@apiserver-rest/ponder-data-client-base";
import { EventBroker } from "@ponder-core/events/eventBroker";
import { SidebarAdvancedSearchButtonComponent } from "./buttons/link-button/sidebar-button-advanced-search.component";

@Component({
    selector: "sidebar",
    imports: [
        AvatarComponent,
        NotificationBubbleComponent,
        SidebarProfileButtonComponent,
        SidebarAccountButtonComponent,
        SidebarFriendsButtonComponent,
        SidebarCollectionButtonComponent,
        SidebarDecksButtonComponent,
        SidebarListsButtonComponent,
        SidebarStatsButtonComponent,
        SidebarHistoryButtonComponent,
        SidebarNewsButtonComponent,
        SidebarSupportButtonComponent,
        SidebarLogoutButtonComponent,
        SidebarAdvancedSearchButtonComponent
    ],
    templateUrl: "./sidebar.component.html"
})
export class SidebarComponent {

    @ViewChild("sidebarpanel") 
    private sidebarPanelRef!: ElementRef<HTMLElement>;

    public authSession?: AuthSession;
    public hasFriendsNotification: boolean = false;
    
    private notificationSub!: Subscription;
    
    public constructor(private elementRef: ElementRef<HTMLElement>, private router: Router, private auth: AuthService, private notifications: NotificationService, private events: EventBroker) {
        this.router.events.pipe(take(1)).subscribe({
            next: (event: Event) => {
                if (event instanceof NavigationStart) {
                    this.onClose();
                }
            }
        });

        this.notificationSub = this.events.ui.onNotificationsUpdated.subscribe(() => {
            this.updateNotificationFlags();
        });
    }

    public ngOnDestroy(): void {
        this.notificationSub?.unsubscribe();
    }

    public ngOnInit(): void {
        this.auth.getSessionAsync().then((authSession?: AuthSession) => {
            this.authSession = authSession;
            this.updateNotificationFlags();
        });
    }

    private onClose(): void {
        this.elementRef.nativeElement.remove();
    }

    private updateNotificationFlags(): void {
        if (!this.authSession) {
            return;
        }

        this.notifications.hasNotificationOfType(NotificationType.FriendPending).then((has: boolean) => {
            this.hasFriendsNotification = has;
        });
    }

    // -------------------------------------------------------------------------------------
    // Global Events
    // -------------------------------------------------------------------------------------

    private mouseDownOutside: boolean = false;

    @HostListener("document:keydown.escape", ["$event"]) 
    private onEscapePressed(event: KeyboardEvent): void {
        this.onClose();
    }

    @HostListener("document:mousedown", ["$event"])
    private onGlobalMouseDown(event: MouseEvent): void {
        if (!this.sidebarPanelRef.nativeElement.contains(event.target as HTMLInputElement)) {
            this.mouseDownOutside = true;
        }
    }

    @HostListener("document:mouseup", ["$event"])
    private onGlobalMouseUp(event: MouseEvent): void {
        // Did the user click outside of our modal panel?
        if (this.mouseDownOutside && !this.sidebarPanelRef.nativeElement.contains((event.target as HTMLInputElement))) {
            this.onClose();
        }

        this.mouseDownOutside = false;
    }
}